import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import RadioButtonsGroup from '../../RadioButtonsGroup';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import styles from './concretedOperationsSource.module.scss';
import {
  CONCRETED_OPERATIONS_INFORMATION,
  PROPERTY_OPERATIONS,
} from '../../constants';
import { setConcretedOperationsSource } from '@/store/slices/components/dashboard/DashboardSlice';
import ConcretedOperationsSourceRow from './concretedOperationsSourceRow';
import PerformanceCard from '../PerformanceCard';
import { useTrackPerformanceTabCard } from '../../customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '../../constants/track';
import ListGroup from '../../RadioButtonsGroup/ListGroup';

export default function ConcretedOperationsSourceContent() {
  const dispatch = useDispatch();
  const { concretedOperationsSource } = useSelector(
    (state) => state.DashboardSlice
  );
  const track = useTrackPerformanceTabCard();
  const { selectedOperation, selectedInformation } = concretedOperationsSource;

  const list =
    concretedOperationsSource[selectedOperation][selectedInformation];

  const handleClickRadio = (item) => {
    dispatch(
      setConcretedOperationsSource({ key: 'selectedOperation', value: item.id })
    );
    track.concretedOperationsSource(TRACK_ELEMENT.RADIO_BUTTON_OPTION);
  };

  const handleClickDropdown = (item) => {
    dispatch(
      setConcretedOperationsSource({
        key: 'selectedInformation',
        value: item.id,
      })
    );
  };

  const allowedOperations = [
    { id: PROPERTY_OPERATIONS.SALE, text: Trans(translations, 'Sale') },
    {
      id: PROPERTY_OPERATIONS.RENT,
      text: Trans(translations, 'Rent'),
    },
  ];

  const concretedOperationsInformation = [
    {
      id: CONCRETED_OPERATIONS_INFORMATION.QUANTITY,
      text: Trans(translations, 'Quantity'),
      checked:
        selectedInformation === CONCRETED_OPERATIONS_INFORMATION.QUANTITY,
    },
    {
      id: CONCRETED_OPERATIONS_INFORMATION.TOTAL_VALUE_USD,
      text: Trans(translations, 'TotalValueInUSD'),
      checked:
        selectedInformation ===
        CONCRETED_OPERATIONS_INFORMATION.TOTAL_VALUE_USD,
    },
  ];

  return (
    <>
      <Box className={styles.radioAndDropdown}>
        <RadioButtonsGroup
          allowedOptions={allowedOperations}
          onClickRadio={handleClickRadio}
          selectedOption={selectedOperation}
        />

        <ListGroup
          list={concretedOperationsInformation}
          onClickItem={handleClickDropdown}
          width="160px"
        />
      </Box>
      <PerformanceCard.Content>
        <Box className={styles.rowsWrapper}>
          {list.map((operation) => (
            <ConcretedOperationsSourceRow
              key={operation.origin}
              name={operation.origin}
              percentage={operation.percentage}
              count={operation.count}
              valueInUsd={operation.value_usd}
              informationMode={selectedInformation}
            />
          ))}
        </Box>
      </PerformanceCard.Content>
    </>
  );
}
